import { map } from 'rxjs/operators';
import { FilterModel } from '@models/outros/filter.model';
import { FilterService } from '@services/outros/filter.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

export interface ChipItemModel {
  param: string;
  label: string;
  disabled: boolean;
}
@Component({
  selector: 'app-filter-chip',
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss']
})
export class FilterChipComponent implements OnInit, OnDestroy {

  selectable = true;
  removable = true;
  addOnBlur = true;
  filters: FilterModel[];
  filtersResult: ChipItemModel[] = [];
  private _subscription: Subscription;

  constructor(
    private _filterService: FilterService
  ) {
    this._subscription = new Subscription();
  }

  ngOnInit(): void {
    this._getFilters();
    this._getFiltersResult();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  remove(item: ChipItemModel): void {
    this._filterService.setClearItem(item);
    this.removeChip(item);
  }

  removeChip(item: ChipItemModel): void {
    const index = this.filtersResult.indexOf(item);
    if (index >= 0) {
      this.filtersResult.splice(index, 1);
    }
  }

  private _addChip(filterParam): void {
    if (!this.filtersResult.find(x => x.param == filterParam)) {
      let item = this.filters.find(x => x.param == filterParam);
      let filter: ChipItemModel = { param: filterParam, label: item.label, disabled: !!item.disabled }
      this.filtersResult.push(filter);
    }
  }

  private _getFilters(): void {
    this._subscription.add(
      this._filterService.getFilters().subscribe(
        (res) => this.filters = res
      )
    )
  }

  private _getFiltersResult(): void {
    this._subscription.add(
      this._filterService.getResults().subscribe(
        res => {
          if (Object.keys(res).length == 0) {
            this.filtersResult = []
          } else {
            if (Object.keys(res).length < this.filtersResult.length) {
              this.filtersResult.map(x => {
                if (!res[x.param]) {
                  this.removeChip(x);
                }
              })
            } else {
              Object.keys(res).map(x => this._addChip(x))
            }
          }
        }
      )
    )
  }
}
